module.exports = __webpack_public_path__ + "media/daizyobu.d36701e3.mp3";